import React, { useState, Fragment, useContext } from 'react';
import { Link, navigate } from 'gatsby';
import { document, window } from 'browser-monads';
import PropTypes from 'prop-types';
import { PROJECT_TYPES } from '../../constants/projectTypes';
import {
  LanguageContext,
  LanguageChangeContext,
  ProjectTypeNavigationContext,
  ProjectTypeNavigationChangeContext,
} from '../../context';

import styles from './navigationMobile.module.css';

function isCurrentTab(locale, frenchLink, englishLink) {
  const link = locale === 'fr' ? frenchLink : englishLink;
  const pathname = window.location.pathname || '';
  if ((pathname === '/' || !pathname) && link === '/actualites') {
    return true;
  }
  return pathname.startsWith(link);
}
function getCorrectTranslation(locale, french, english) {
  return locale === 'fr' ? french : english;
}

const LanguagePicker = (props) => {
  const { locale } = props;
  const onChangeLocale = useContext(LanguageChangeContext);
  const onChangeLang = (newLocale) => {
    if (newLocale === locale) return;
    onChangeLocale(newLocale);
  };
  return (
    <div className={styles.language}>
      <span
        className={`${styles.lang} ${locale === 'en-US' ? styles.currentLanguage : ''}`}
        onClick={() => onChangeLang('en-US')}
      >
        ENG
      </span>{' '}
      -{' '}
      <span
        className={`${styles.lang} ${locale === 'fr' ? styles.currentLanguage : ''}`}
        onClick={() => onChangeLang('fr')}
      >
        FR
      </span>
    </div>
  );
};
LanguagePicker.propTypes = {
  locale: PropTypes.string.isRequired,
};

const ProjectNavigation = (props) => {
  const { locale, isOpen, toggleNav } = props;
  const typesNumber = Object.keys(PROJECT_TYPES).length;
  const currentType = useContext(ProjectTypeNavigationContext);
  const onChangeProjectType = useContext(ProjectTypeNavigationChangeContext);
  function onTypeClick(type) {
    document.body.style.overflowY = 'auto';
    onChangeProjectType(type);
    if (!['/projects', '/projets'].includes(window.location.pathname))
      navigate(`/${locale === 'fr' ? 'projets' : 'projects'}`);
    else toggleNav(!isOpen);
  }
  return (
    <ul className={styles.subFilter}>
      {[{ value: 'all', fr: 'Tous', 'en-US': 'All' }, ...Object.values(PROJECT_TYPES)].map((type, index) => {
        if (index < typesNumber)
          return (
            <Fragment key={type.value}>
              <li
                onClick={() => onTypeClick(type.value)}
                className={`${currentType.includes(type.value) ? styles.selectedSubFilter : ''} ${
                  styles.navigationItem
                }`}
              >
                {type[locale]}
              </li>
            </Fragment>
          );
        return (
          <li
            key={type.value}
            onClick={() => onTypeClick(type.value)}
            className={currentType.includes(type.value) ? styles.selectedSubFilter : ''}
          >
            {type[locale]}
          </li>
        );
      })}
    </ul>
  );
};
ProjectNavigation.propTypes = {
  locale: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleNav: PropTypes.func.isRequired,
};

const NavigationMobile = () => {
  const locale = useContext(LanguageContext);

  const [isOpen, toggleNav] = useState(false);
  const [isProjectNavOpen, toggleProject] = useState(false);

  const onNavClick = () => {
    // since useState is async, we used isOpen value before new assignment.
    // Because we want the overflow to be hidden if the nav is open.
    document.body.style.overflowY = isOpen ? 'auto' : 'hidden';
    toggleNav(!isOpen);
  };

  const onMenuItemClick = (event) => {
    event.preventDefault();
    onNavClick();
  };

  return (
    <>
      <div className={`${styles.nav} ${isOpen ? styles.open : ''}`} onClick={onNavClick}>
        <span />
        <span />
        <span />
      </div>
      {isOpen && (
        <div className={styles.menu}>
          <ul className={styles.ul}>
            <li
              className={`${styles.navigationItem} ${
                isCurrentTab(locale, '/actualites', '/news') ? styles.currentTab : ''
              }`}
              onClick={onMenuItemClick}
            >
              <Link to={`/${getCorrectTranslation(locale, 'actualites', 'news')}`}>
                {getCorrectTranslation(locale, 'Actualités', 'News')}
              </Link>
            </li>
            <li
              className={`${styles.navigationItem} ${
                isCurrentTab(locale, '/projets', '/projects') ? styles.currentTab : ''
              }`}
              onClick={() => toggleProject(!isProjectNavOpen)}
            >
              {`${isProjectNavOpen ? '-' : '+'} ${getCorrectTranslation(locale, 'Projets', 'Projects')}`}
            </li>
            {isProjectNavOpen && (
              <li>
                <ProjectNavigation locale={locale} isOpen={isOpen} toggleNav={toggleNav} />
              </li>
            )}
            <li
              className={`${styles.navigationItem} ${
                isCurrentTab(locale, '/agence', '/agency') ? styles.currentTab : ''
              }`}
              onClick={onMenuItemClick}
            >
              <Link to={`/${getCorrectTranslation(locale, 'agence', 'agency')}`}>
                {getCorrectTranslation(locale, 'Agence', 'Agency')}
              </Link>
            </li>
            <li
              className={`${styles.navigationItem} ${
                isCurrentTab(locale, '/contact', '/contact-us') ? styles.currentTab : ''
              }`}
              onClick={onMenuItemClick}
            >
              <Link to={`/${getCorrectTranslation(locale, 'contact', 'contact-us')}`}>Contact</Link>
            </li>
          </ul>
          <LanguagePicker locale={locale} />
        </div>
      )}
    </>
  );
};

export default NavigationMobile;
